// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8f02092","455":"10988f4b","977":"9f8e4a46"}[chunkId] + ".chunk.js";
};